<template>
  <div class="input-group">
    <b-input
      id="footer-email"
      type="text"
      placeholder="E-mail"
      size="sm"
    ></b-input>
    <div class="input-group-append">
      <span class="input-group-text">
        <font-awesome-icon icon="envelope"></font-awesome-icon>
      </span>
    </div>
  </div>
</template>
<script>
export default {};
</script>
